import BaseService from './../../base'

class RoleService extends BaseService {
  // 获取角色列表
  async roleListApi (params={}) {
    return await this.get('/admin/role', params);
  }

  // 创建数据
  async createRoleApi (params={}) {
    return await  this.post('/admin/role', params);
  }

  // 更新角色
  async updateRoleApi (id, params={}) {
    return await  this.patch(`/admin/role/${id}`, params)
  }

  // 删除角色
  async deleteRoleApi (id) {
    return await  this.delete(`/admin/role/${id}`);
  }

  // 根据角色id获取已经授权的菜单
  async roleAccessByRoleIdApi (roleId) {
    return await this.get(`/admin/role_access/${roleId}`);
  }

  // 获取全部的资源
  async roleAccessListApi() {
    return await this.get('/admin/role_access');
  }

}

export default new RoleService()
